import { useAuth } from '../../../App';

/**
 * The EasyChit audit log (`POST /api/Change/SaveData`) stores a `loginName` for
 * every change. The Angular app read it from its own Auth service; the ported
 * React screens were reading `localStorage.getItem('loginName')`, a key EasyITSM
 * never writes — so every audit row was saved with an empty user. Read the real
 * signed-in ITSM user instead.
 */
export function useLoginName() {
  const { user } = useAuth();
  return user?.name || user?.email || 'unknown';
}

/** Mirrors Auth.buildAudit(changeType, { oldData, newData }, reason) from the Angular app. */
export function buildAuditEntry({ schemaName, loginName, changeType, oldData, newData, reason }) {
  return {
    schemaName: schemaName ?? null,
    loginName: loginName || 'unknown',
    loginTime: new Date().toISOString(),
    changeType,
    oldData,
    newData,
    reason,
  };
}

/** Pulls the most useful message out of an axios error for a user-facing toast. */
export function apiErrorMessage(err, fallback) {
  const data = err?.response?.data;
  if (typeof data === 'string' && data.trim()) return data.split('\n')[0].slice(0, 300);
  if (data?.detail) return String(data.detail).slice(0, 300);
  if (data?.title) return String(data.title).slice(0, 300);
  // Every EasyChit controller answers with `new { Message = "..." }`. Without this
  // those bodies fell through to err.message, i.e. "Request failed with status
  // code 404" instead of the reason the server actually gave.
  if (data?.Message) return String(data.Message).slice(0, 300);
  if (data?.message) return String(data.message).slice(0, 300);
  if (err?.message) return err.message;
  return fallback;
}
